// extracted by mini-css-extract-plugin
export var brand = "_3r-9";
export var compact = "_3r-6";
export var extraSmall = "_3r-7";
export var icon = "_3r-0";
export var large = "_3r-4";
export var light = "_3r-1";
export var medium = "_3r-5";
export var outline = "_3r-b";
export var primaryDark = "_3r-a";
export var primaryLight = "_3r-8";
export var primaryModern = "_3r-c";
export var success = "_3r-2";
export var successSolid = "_3r-3";